import '.ep{font-size:1.125rem;}.ssr-plugin'
import '.du{line-height:1.75rem;}.ssr-plugin'
import '.ia{text-decoration:none;}.ssr-plugin'
import '.g2{color:var(--primary-red);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="ep du"
    >
      {translations.privacySubtitle}{' '}
      <a className="ia g2"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="ia g2"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
